export const CURRENT_VERSION = "1.0.0";
export const BETA = "Beta";
export const CURRENT_VERSION_LABEL = `v${CURRENT_VERSION}`;
